module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/contacts/img_about03-6c2a45f0af7ff7fb0288368f711590c7.png";